module.exports = __webpack_public_path__ + "media/images/xpass/icons/brands/inactive/akt-e87bd9d50a64f97b2e693423ab1d3da9.png";